import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="font-heading text-xl md:text-2xl font-black text-foreground-950 tracking-tight">
              911<span className="text-accent-500">爆料网</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.href
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
            <button
              type="button"
              className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              投稿爆料
            </button>
          </div>

          <button
            type="button"
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2.5 text-sm font-medium rounded-lg transition-colors ${
                  location.pathname === link.href
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <hr className="border-background-200/70 my-1" />
            <Link
              to="/about"
              className="px-4 py-2.5 text-sm font-medium text-foreground-600 hover:bg-background-100 rounded-lg transition-colors"
            >
              关于我们
            </Link>
            <button
              type="button"
              className="px-4 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-full transition-all duration-200 text-center cursor-pointer"
            >
              投稿爆料
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}